export interface Labeled {
  label: string;
  labelPosition: LabelPosition;
}

export type LabelPosition = 'top' | 'left';
export const labelPositions = ['top', 'left'] as const;
